import React, { useState } from 'react';
import {
  Typography,
  Button,
  Paper,
  Alert,
  Container
} from '@mui/material';
import config from '../config';
import { useParams } from 'react-router-dom';
const server_URL = config.SERVER_URL;

const Subscribed = () => {
  const email = useParams();
  const [alert, setAlert] = useState({
    show: false,
    type: '',
    message: '',
  });

  const handleSubscribe = async () => {
    try {
      const response = await fetch(`${server_URL}/subscribe`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          method: 'subscribe',
          email: email // Get email from URL params or state
        }),
      });

      const data = await response.json();

      if (data.status === '1') {
        setAlert({
          show: true,
          type: 'success',
          message: 'Successfully resubscribed!'
        });
      } else {
        setAlert({
          show: true,
          type: 'error',
          message: data.message || 'Failed to resubscribe'
        });
      }
    } catch (error) {
      setAlert({
        show: true,
        type: 'error',
        message: 'An error occurred while processing your request'
      });
    }
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 8 }}>
      <Paper 
        elevation={3} 
        sx={{ 
          p: 4, 
          textAlign: 'center',
          borderRadius: 2,
          backgroundColor: 'white'
        }}
      >
        {alert.show && (
          <Alert 
            severity={alert.type} 
            sx={{ mb: 3 }}
            onClose={() => setAlert({ ...alert, show: false })}
          >
            {alert.message}
          </Alert>
        )}

        <Typography variant="h4" gutterBottom sx={{ color: '#333' }}>
          Welcome to our mailing list!
        </Typography>
        
        <Typography variant="body1" sx={{ color: '#666', mb: 2 }}>
          You have been successfully subscribed to our mailing list.
        </Typography>
        
       
      </Paper>
    </Container>
  );
};

export default Subscribed; 